document.querySelectorAll('.hacklabr-slider-block').forEach((container) => {
    const params = JSON.parse(container.querySelector('script').innerHTML);

    const swiper = hl_createSwiper(container.querySelector('.swiper'), {
        ...params,
        on: {
            init: function () {
                const activeSlide = this.slides[this.activeIndex];
                if (activeSlide) {
                    setTimeout(() => {
                        activeSlide.classList.add('swiper-slide--animated');
                    }, 200);
                }
            },
            slideChangeTransitionStart: function () {
                this.slides.forEach((slide) => slide.classList.remove('swiper-slide--animated'));
            },
            slideChangeTransitionEnd: function () {
                const activeSlide = this.slides[this.activeIndex];
                if (activeSlide) {
                    setTimeout(() => {
                        activeSlide.classList.add('swiper-slide--animated');
                    }, 200);
                }
            },
        },
    });
});
